import { QueryKey } from '@tanstack/react-query';
import { getRecentActivity } from '../api/get-recent-activity';
import { updateUser } from '../api';

const baseKey: QueryKey = ['users'] as const;

export const usersQueryKeys = {
  base: baseKey,
  getUserProfile: [...baseKey, 'getUserProfile'],
  getUsers: [...baseKey, 'get'],
  getUser: [...baseKey, 'getUser'],
  createUser: [...baseKey, 'createUser'],
  updateUser: [...baseKey, 'updateUser'],
  deleteUser: [...baseKey, 'deleteUser'],
  getRecentActivity: [...baseKey, 'getRecentActivity'],
  getUserInfo: ['userInfo'],
  uploadCsv: [...baseKey, 'uploadCSV'],
} as const;
